// extracted by mini-css-extract-plugin
module.exports = {"recomendations":"Recomendations_recomendations__YQwpa","recommendations__button":"Recomendations_recommendations__button__10bcv"};